import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const TechnologyPage = () => {
  const features = [
    {
      icon: 'ri-vr-line',
      title: 'Immersion totale',
      description: 'Voyagez vers des destinations relaxantes pendant votre massage : plages tropicales, forêts apaisantes, montagnes sereines.'
    },
    {
      icon: 'ri-headphone-line',
      title: 'Expérience sensorielle',
      description: 'Combinaison parfaite de stimuli visuels, sonores et tactiles pour une relaxation profonde du corps et de l\'esprit.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Réduction du stress',
      description: 'La réalité virtuelle aide à déconnecter complètement de l\'environnement stressant et favorise la production d\'endorphines.'
    },
    {
      icon: 'ri-star-line',
      title: 'Innovation unique en RDC',
      description: 'HMC CLINIC est la première clinique à proposer cette technologie révolutionnaire à Lubumbashi et dans toute la RDC.'
    }
  ];

  const advantages = [
    {
      title: 'Technologie de pointe',
      description: 'Équipements VR dernière génération pour une expérience immersive optimale',
      icon: 'ri-rocket-line'
    },
    {
      title: 'Thérapeutes formés',
      description: 'Notre équipe est spécialement formée pour combiner massage et technologie VR',
      icon: 'ri-user-star-line'
    },
    {
      title: 'Environnements variés',
      description: 'Large choix de destinations virtuelles adaptées à vos préférences',
      icon: 'ri-landscape-line'
    },
    {
      title: 'Résultats prouvés',
      description: 'Études scientifiques démontrant l\'efficacité de la VR pour la relaxation',
      icon: 'ri-bar-chart-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pt-20 bg-gradient-to-br from-primary via-primary-dark to-[#0F172A]">
        <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/4f781b3d9ed7a79e9df469df8faca21b.jpg')] opacity-10 bg-cover bg-center"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-20 w-full relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto space-y-8"
          >
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <i className="ri-vr-line text-white"></i>
              <span className="text-sm font-medium text-white">Innovation</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-7xl font-bold text-white leading-tight">
              VR Massage
            </h1>
            <p className="text-xl lg:text-2xl text-white/90 leading-relaxed">
              L'innovation bien-être arrive à Lubumbashi : une expérience immersive unique combinant massage thérapeutique et réalité virtuelle
            </p>
            <a
              href="https://wa.me/243850465500"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <span>Découvrir l'expérience VR</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </motion.div>
        </div>
      </section>

      {/* What is VR Massage */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900">
                Qu'est-ce que le VR Massage ?
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Le VR Massage est une innovation révolutionnaire qui combine les bienfaits du massage thérapeutique traditionnel avec une immersion visuelle et sonore en réalité virtuelle.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Pendant votre séance, vous portez un casque VR qui vous transporte dans des environnements apaisants de votre choix, tandis que notre massothérapeute professionnel travaille sur votre corps. Cette synchronisation crée une expérience de relaxation totale, unique en son genre.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-4">
                <div className="bg-primary/5 rounded-2xl p-6">
                  <div className="text-3xl font-bold text-primary mb-2">45-75min</div>
                  <div className="text-sm text-gray-600">Durée de la séance</div>
                </div>
                <div className="bg-primary/5 rounded-2xl p-6">
                  <div className="text-3xl font-bold text-primary mb-2">1ère</div>
                  <div className="text-sm text-gray-600">En RDC</div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=person%20wearing%20VR%20headset%20during%20professional%20massage%20therapy%20in%20modern%20high-tech%20wellness%20center%2C%20futuristic%20healthcare%20innovation%2C%20blue%20ambient%20lighting%2C%20clean%20minimalist%20design%2C%20immersive%20relaxation%20experience&width=800&height=600&seq=vr1&orientation=landscape"
                alt="VR Massage Experience"
                className="rounded-3xl shadow-2xl w-full h-[500px] object-cover object-top"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Une expérience multisensorielle
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Découvrez les caractéristiques uniques du VR Massage
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl mb-6">
                  <i className={`${feature.icon} text-3xl text-primary`}></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-gray-900 mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Pourquoi choisir le VR Massage ?
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-primary rounded-full mx-auto mb-6">
                  <i className={`${advantage.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="font-semibold text-xl text-gray-900 mb-3">
                  {advantage.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {advantage.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="py-24 bg-gradient-to-br from-primary to-primary-dark text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <h2 className="font-serif text-4xl lg:text-5xl font-bold">
                Une première en République Démocratique du Congo
              </h2>
              <p className="text-xl text-white/90 leading-relaxed">
                HMC CLINIC est fière d'être la première clinique de bien-être à introduire la technologie VR Massage en RDC. Nous croyons en l'innovation au service de votre santé et de votre bien-être.
              </p>
              <p className="text-lg text-white/80 leading-relaxed">
                Notre engagement envers l'excellence nous pousse à rechercher constamment les meilleures technologies et pratiques internationales pour les rendre accessibles à Lubumbashi et dans tout le Haut-Katanga.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="grid grid-cols-2 gap-6"
            >
              {[
                { icon: 'ri-award-line', text: 'Technologie certifiée' },
                { icon: 'ri-global-line', text: 'Standards internationaux' },
                { icon: 'ri-shield-check-line', text: 'Sécurité garantie' },
                { icon: 'ri-customer-service-line', text: 'Support expert' }
              ].map((item, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                  <i className={`${item.icon} text-4xl mb-4`}></i>
                  <p className="font-medium">{item.text}</p>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-20 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900">
              Prêt à vivre l'expérience VR Massage ?
            </h2>
            <p className="text-xl text-gray-600">
              Réservez votre séance et découvrez une nouvelle dimension de relaxation
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://wa.me/243850465500"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Réserver une séance VR</span>
              </a>
              <Link
                to="/nos-services"
                className="inline-flex items-center space-x-3 bg-white hover:bg-gray-50 text-primary border-2 border-primary px-8 py-4 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                <span>Voir tous les services</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TechnologyPage;